/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Mobile style layout",
  "description": "Like Kitten: switches the editor between a stage/sprites view and a code view, with the block palette on the right in code view.",
  "tags": [
    "theme"
  ],
  "credits": [
    {
      "name": "OpenWarp"
    }
  ],
  "enabledByDefault": false,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "userstyle.css"
    }
  ],
  "settings": [
    {
      "name": "Default view",
      "id": "defaultView",
      "type": "select",
      "potentialValues": [
        {
          "id": "stage",
          "name": "Stage & Sprites"
        },
        {
          "id": "code",
          "name": "Code"
        }
      ],
      "default": "stage"
    }
  ],
  "dynamicDisable": true
};
export default manifest;
